const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/users/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
import { validateAdminUserListSearch } from "./admin-user-list-search";
type AdminUserListItem = RouterOutputs["adminUsers"]["list"]["items"][number];
export const Route = createFileRoute("/_app/admin/users/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Users")
    }]
  }),
  validateSearch: validateAdminUserListSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});